import { CommonEnums } from '../../common.enums';
export class MongoDB_Inst {
    mongoDB_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxFlow_Id: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    disableFlg: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;
    src_ConnNm: string;
    tgt_ConnNm: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.mongoDB_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxFlow_Id = CommonEnums.defaults.STRING_EMPTY;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.retryEnabled = CommonEnums.defaults.STRING_EMPTY;
        this.numOfRetryAttempts = CommonEnums.defaults.LONG_VAL
        this.retryWaitTime = CommonEnums.defaults.LONG_VAL
        this.src_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.tgt_ConnNm = CommonEnums.defaults.STRING_EMPTY;
    }

    copy(): MongoDB_Inst {
        let mongoDB_InstTmp: MongoDB_Inst = new MongoDB_Inst();

        mongoDB_InstTmp.mongoDB_Inst_Id = this.mongoDB_Inst_Id;
        mongoDB_InstTmp.nm = this.nm;
        mongoDB_InstTmp.description = this.description;
        mongoDB_InstTmp.ver = this.ver;
        mongoDB_InstTmp.valid_Cd = this.valid_Cd;
        mongoDB_InstTmp.dxFlow_Id = this.dxFlow_Id;
        mongoDB_InstTmp.updateBy = this.updateBy;
        mongoDB_InstTmp.lastUpdateBy = this.lastUpdateBy;
        mongoDB_InstTmp.updateDt = this.updateDt;
        mongoDB_InstTmp.retryEnabled = this.retryEnabled;
        mongoDB_InstTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        mongoDB_InstTmp.retryWaitTime = this.retryWaitTime;
        mongoDB_InstTmp.src_ConnNm = this.src_ConnNm;
        mongoDB_InstTmp.tgt_ConnNm = this.tgt_ConnNm;
        mongoDB_InstTmp.disableFlg = this.disableFlg;
        return mongoDB_InstTmp;
    }

    copyFrom(mongoDB_InstTmp: MongoDB_Inst): void {
        this.mongoDB_Inst_Id = mongoDB_InstTmp.mongoDB_Inst_Id;
        this.nm = mongoDB_InstTmp.nm;
        this.description = mongoDB_InstTmp.description;
        this.ver = mongoDB_InstTmp.ver
        this.valid_Cd = mongoDB_InstTmp.valid_Cd
        this.dxFlow_Id = mongoDB_InstTmp.dxFlow_Id
        this.updateBy = mongoDB_InstTmp.updateBy
        this.lastUpdateBy = mongoDB_InstTmp.lastUpdateBy;
        this.updateDt = mongoDB_InstTmp.updateDt
        this.src_ConnNm = mongoDB_InstTmp.src_ConnNm
        this.retryEnabled = mongoDB_InstTmp.retryEnabled;
        this.numOfRetryAttempts = mongoDB_InstTmp.numOfRetryAttempts;
        this.retryWaitTime = mongoDB_InstTmp.retryWaitTime;
         this.tgt_ConnNm = mongoDB_InstTmp.tgt_ConnNm;
        this.disableFlg = mongoDB_InstTmp.disableFlg;
    }

    compare(mongoDB_InstTmp: MongoDB_Inst): string {
        let mongoDB_InstString: string = this.toString(false);
        let mongoDB_InstTmpString: string = mongoDB_InstTmp.toString(false);

        if (mongoDB_InstString != mongoDB_InstTmpString) {
            return mongoDB_InstString + ', ' + mongoDB_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "MongoDB_Inst [mongoDB_Inst_Id=" + this.mongoDB_Inst_Id +
            ", nm=" + this.nm +
            ", description=" + this.description +
            ", ver=" + this.ver +
            ", valid_Cd=" + this.valid_Cd +
            ", dxFlow_Id=" + this.dxFlow_Id +
            ", updateBy=" + this.updateBy +
              ", updateDt=" + this.updateDt +
            ",disableFlg="+ this.disableFlg +
            ", retryEnabled =" + this.retryEnabled +
            ", numOfRetryAttempts =" + this.numOfRetryAttempts +
            ", retryWaitTime =" + this.retryWaitTime; 
           
            

            if (isNotCompare) {
                str = ",lastUpdateBy=" + this.lastUpdateBy + 
                ",  src_ConnNm =" + this.src_ConnNm +
                ",    tgt_ConnNm =" + this.tgt_ConnNm ;

    
            }
    
            str += ']';
            return str;
        }
    }
    
